import { asDate, asDatetime } from '@mgdis/date-utils';
class DateFormatterService {
    locale = 'fr-FR';
    timeZone;
    /**
     * Wrapper around mgdis date-utils functions to automatically apply timeZone and locale settings
     * @param options - format options
     */
    constructor({ timeZone }) {
        this.timeZone = timeZone;
    }
    /**
     * Default formatter options
     * @returns formatter options
     */
    defaultOptions() {
        return { timeZone: this.timeZone, locale: this.locale };
    }
    /**
     * Set a new timezone for this formatter
     * @param timeZone - ex: Europe/Paris
     */
    setTimeZone(timeZone) {
        this.timeZone = timeZone;
    }
    /**
     * Get the configured timeZone
     * @returns timeZone
     */
    getTimeZone() {
        return this.timeZone;
    }
    /**
     * Returns an human formatted date
     * @param date - date in string format (ex: 2022-03-03)
     * @param options - format options
     * @returns a formatted date
     */
    asDate(date, options) {
        return asDate(date, { ...this.defaultOptions(), ...options });
    }
    /**
     * Returns an human formatted datetime
     * @param date - datetime in string format (ex: 2022-03-03T23:00:00.000Z)
     * @param options - format options
     * @returns a formatted datetime
     */
    asDatetime(date, options) {
        return asDatetime(date, { ...this.defaultOptions(), ...options });
    }
}
export { DateFormatterService };
//# sourceMappingURL=date-formatter-service.js.map